import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { throwApiError } from "./apiError";
import { getTerminalId } from "../helpers";

/**
 * POST API call to send disposition mail
 * @param osdNumber - The OSD number to be replaced in the URL
 * @param params - The parameters for the API call
 */
export const sendDispositionMailApi = async (osdNumber: string | undefined, params: any = {}, files: File[] = [], apiHeaders: Record<string, string> = {}) => {
  try {
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files', file);
    });
    if (params.proNumber) {
      formData.append('proNumber', params.proNumber.toString());
    }
    formData.append("to", JSON.stringify(params.to));

    const normalizeRecipients = (value: any): string[] | undefined => {
      if (!value) return undefined;
      if (Array.isArray(value)) return value.map((v: any) => v.toString()).filter(Boolean);
      return [value.toString()].filter(Boolean);
    };

    const to = normalizeRecipients(params?.to);
    if (to?.length) {
      formData.set("to", JSON.stringify(to));
    }

    const cc = normalizeRecipients(params?.cc);
    if (cc?.length) {
      formData.append("cc", JSON.stringify(cc));
    }

    const bcc = normalizeRecipients(params?.bcc);
    if (bcc?.length) {
      formData.append("bcc", JSON.stringify(bcc));
    }
    formData.append("subject", params.subject);
    formData.append("html", params.html);
    formData.append(
      "attachmentImageUrls",
      JSON.stringify(params.attachmentImageUrls)
    );
    formData.append("emailType", params.emailType);

    // Add required headers as FormData fields for backend compatibility
    const headers: Record<string, string> = {
      "OSD-Module-Name": "damagesOrRefusals",
      "OSD-Section-Name": "dispositionEmail",
      "OSD-Action-Type": "send",
      "OSD-Destination-Terminal": getTerminalId(),
      ...apiHeaders, // Include any additional headers from the hook

    } ;

    params = formData;
    const response = await axios.post(getUrl(ApiType.SEND_MAIL).replace(":osdNumber", osdNumber ?? ""), params, {headers});
    return response.data;
  } catch (error: any) {
    throwApiError(error, ErrorMessages.sendDispositionMail, { badRequestOrder: "errorsFirst" });
  }
}; 